import {
    SET_STATS,
    SET_STATS_LOADING
} from './actions';

export const initialState = {
    dashboardDetails: {},
    loadindDashboardStats: false,
}

export const dashboard = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_STATS:
            return { ...state, dashboardDetails: action.payload || {} };
        case SET_STATS_LOADING:
            return { ...state, loadindDashboardStats: action.payload };
        default:
            return state;
    }
}